import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/cn';
import type { BaseInstance } from '@pigello/pigello-matrix';
import type { Path } from 'react-hook-form';
import type { FieldProps } from '../types';
import { accountnumberregexp, parseFieldValue } from '../utils';

export function AccountNumber<Instance extends BaseInstance = BaseInstance>({
  formField,
  name,
  placeholder,
  label,
  description,
  className,
  horizontal,
  disabled,
  canHandleField,
  onValueChange,
}: FieldProps<Instance> & { onValueChange?: (value: unknown) => void }) {
  if (horizontal) {
    return (
      <FormField
        rules={{
          required: formField.required && 'Detta fält är obligatoriskt',
        }}
        control={formField.control}
        name={name as Path<Instance>}
        render={({ field }) => (
          <FormItem
            className={cn('flex items-center justify-between', className)}
          >
            <div className='w-1/2 shrink-0'>
              <FormLabel>
                {label ?? formField.label}{' '}
                {formField.required && <span>*</span>}
              </FormLabel>
              {(description || formField.description) && (
                <FormDescription>
                  {description ?? formField.description}
                </FormDescription>
              )}

              <FormMessage />
            </div>
            <FormControl>
              <Input
                maxLength={36}
                {...field}
                onChange={(e) => {
                  const parsed = parseFieldValue({
                    newValue: e.target.value,
                    prevValue: field.value,
                    regex: accountnumberregexp,
                  });
                  field.onChange(parsed);
                  onValueChange?.(parsed);
                }}
                value={field.value ?? ''}
                placeholder={placeholder ?? formField.label}
                disabled={disabled ?? field.disabled ?? !canHandleField}
              />
            </FormControl>
          </FormItem>
        )}
      />
    );
  }
  return (
    <FormField
      rules={{
        required: formField.required && 'Detta fält är obligatoriskt',
      }}
      control={formField.control}
      name={name as Path<Instance>}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel>
            {label ?? formField.label} {formField.required && <span>*</span>}
          </FormLabel>
          <FormControl>
            <Input
              maxLength={36}
              {...field}
              onChange={(e) => {
                const parsed = parseFieldValue({
                  newValue: e.target.value,
                  prevValue: field.value,
                  regex: accountnumberregexp,
                });
                field.onChange(parsed);
                onValueChange?.(parsed);
              }}
              value={field.value ?? ''}
              placeholder={placeholder ?? formField.label}
              disabled={disabled ?? field.disabled ?? !canHandleField}
            />
          </FormControl>
          {(description || formField.description) && (
            <FormDescription>
              {description ?? formField.description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
